<h4 class="h3 guts-p-b-1">
  {{ collectionName }}
</h4>
<div class="guts-p-b-4 search-error crap">
  <p class="par par--small par--light guts-p-b-1">
    {{ errorMessage }}
  </p>
</div>
